import { Component, Injector, Input, OnInit } from '@angular/core';
import { GridActionHandlerBase } from '../../../../../components/common/grid-base/actions/grid-action-handler-base';
import { TabConfig } from '../../../../../components/common/pollux-tab-config/pollux-form-config';
import { WorkplaceBase } from '../../../../../components/common/workplace-base/workplace-base';
import { WorkspaceBase } from '../../../../../components/common/workspace-base/workspace-base';

/**
 * Tenants workspace
 */
@Component({
  selector: 'tenants-workspace',
  templateUrl: './tenants-workspace.component.html',
  styleUrls: ['./tenants-workspace.component.scss']
})
export class TenantsWorkspaceComponent extends WorkspaceBase implements OnInit {
  /**
   * JavaScript Oid property name of BO (in this case Tenant DTO)
   */
  public oidPropertyName = "oid";

  /**
   * Show the form
   * @param oid Oid of the item that should be loaded in the form. Use -1 for new mode
   */
  public showForm(oid: number): void {
    this.showGrid = false;
    this.oid = oid;
  }

  /**
   * The workplace
   */
  private _workplace: WorkplaceBase;

  /**
   * Sets the workplace
   */
  @Input() public set workplace(workplace: WorkplaceBase) {
    this._workplace = workplace;
  }

  /**
   * Gets the workplace
   */
  public get workplace(): WorkplaceBase {
    return this._workplace;
  }

  /**
   * The tab element
   */
  private _tabElement: TabConfig;

  /**
   * Sets te tab element
   */
  @Input() public set tabElement(tabElement: TabConfig) {
    this._tabElement = tabElement;
  }

  /**
   * Gets the tab element
   */
  public get tabElement(): TabConfig {
    return this._tabElement;
  }

  /**
   * Parent report OID
   */
  private _parentReportId = -1;

  /**
   * Gets the parent report OID
   */
  public get parentReportId() {
    return this._parentReportId;
  }

  /**
   * Constructor
   * @param injector The Angular injector
   */
  constructor(protected injector: Injector) {
    super(injector);
  }

  /**
   * Action handlers used by this workspace area.
   */
  protected get actionHandlers(): GridActionHandlerBase[] {
    return [];
  }

  /**
   * Called if the grid state was changed. Use this to notify the nav bar or perform similar actions
   * @param gridState The new grid state: true: Grid is shown, so the form isn't shown. False: Grid isn't show, but the form is shown
   */
  protected onShowGridChanged(gridState: boolean): void {
    this.eventBus.broadcastEvent('showGridChanged', { area: 'projectValuationTenant', value: gridState });
  }

  /**
   * Registers any required events. Please don't forget to unsubscibe!
   */
  protected registerEvents(): void {
    this.onEvents.push(this.eventBus.subscribeEvent('closeTenantForm', (_payload, _options) => {
      this.showGrid = true;
      this.oid = null;
      this.eventBus.broadcastEvent('showSaveCancelNavigationAction', false);
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('backClickedTrue', (_payload, _options) => { this.showGrid = true; }));
  }

  /**
   * Applies a filter if an element was selected in a higher hierarchy area
   * @param _filter Filter settings
   * @param _selectedHierarchy Hierarchy where the element was selected
   * @param _tabConfig Tab config
   * @param reset Reset the selection in the current area
   */
  public filter(item: any, selectedHierarchy: number, tabConfig: any, _reset: boolean): void {
    this._parentReportId = -1;

    if (selectedHierarchy != null) {
      const filteredTab = tabConfig[selectedHierarchy];
      if (filteredTab.searchMode === 'report') {
        this._parentReportId = item.Oid;
      }
    }
    
    this.grid.loadData({
      skip: 0
    });
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.init();

    this.workplace.onTabCreated(this);
  }
}
